export const ACCOUNT_NUMBER = 1;
export const POSTED_DATE = 2;
export const CHECK_NUMBER = 3;
export const AMOUNT = 4;
export const PAYEE = 5;
export const DUPLICATE_CHECK = 6;
